export type CancelFunctions = {
  [key: string]: () => {} | void;
};

export type CodeNameModel = {
  id?: string;
  code: string;
  name: string;
  nameWithMediaOwner?: string;
  category?: string;
  environment?: string;
  publisher?: string;
  include?: boolean;
  mediaOwner?: string;
};

export type RequiredWith<T, K extends keyof T> = T & { [P in K]-?: T[P] };

export interface FileContent extends CodeNameModel {}

export type FileList = {
  file?: File;
  fileId?: number;
  dynamoDbFileId?: string;
  include?: boolean;
  name: string;
  fileContents?: FileContent[];
  preferredPricing?: Record<string, number>;
  mediaOwner?: string;
  excludedFrameCodes?: string[];
};

export enum CreativeType {
  VIDEO = 'VIDEO',
  BANNER = 'BANNER',
  DYNAMIC = 'DYNAMIC',
}
